export const changeTypeOptions = [
    { value: "Budget", label: "Budget" },
    { value: "Client Request", label: "Client Request" },
    { value: "Scope Change", label: "Scope Change" },
    { value: "Budget Transfer", label: "Budget Transfer" },

];

export const statusOptions = [
    { label: "Open", value: "Open" },
    { label: "Closed", value: "Closed" },
];

export const scopeImpactOptions = [
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" }
];

export const timeImpactOptions = [
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" }
];

export const costImpactOptions = [
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" }
];

export const changeFinalStatusOptions = [
    { value: "Accepted", label: "Accepted" },
    { value: "Rejected", label: "Rejected" },

];
export const changeRaisedOptions = [
    { value: "Change Order Raised", label: "Change Order Raised" },
    { value: "Change Order Received", label: "Change Order Received" },

];

export const actionOptions = [
    { value: "Technical Team", label: "Technical Team" },
    { value: "Management", label: "Management" },
    { value: "Client", label: "Client" },
    { value: "Contractor", label: "Contractor" },
    { value: "Consultant", label: "Consultant" }
];
export const changeIssueOptions = [
    { value: "true", label: "Yes" },
    { value: "false", label: "No" }
];
export const contractPackageOptions = [
    { value: "active", label: "Active", color: "#3b82f6" },
    { value: "expired", label: "Expired", color: "#8b5cf6" },
    { value: "terminated", label: "Terminated", color: "#dc2626" },
    { value: "renewed", label: "Renewed", color: "#8b5cf6" }
];

export const entities = [
    { value: "Action Tracker", label: "Action Tracker" },
    { value: "As-Built Drawings", label: "As-Built Drawings" },
    { value: "Baseline Schedule", label: "Baseline Schedule" },
    { value: "Change Management - Authority Initiated", label: "Change Management - Authority Initiated" },
    { value: "Claims Management", label: "Claims Management" },
    { value: "Contractor Claim", label: "Contractor Claim" },
    { value: "Financial Management (Retention)", label: "Financial Management (Retention)" },
    { value: "Financial Securities (BG)", label: "Financial Securities (BG)" },
    { value: "HSE Management Plan", label: "HSE Management Plan" },
    { value: "IFC", label: "IFC" },
    { value: "Implementation Schedule", label: "Implementation Schedule" },
    { value: "Invoice", label: "Invoice" },
    { value: "Invoice Management", label: "Invoice Management" },
    { value: "Master Development Schedule", label: "Master Development Schedule" },
    { value: "Quality Management Plan", label: "Quality Management Plan" },
    { value: "Re-Baseline Schedule", label: "Re-Baseline Schedule" },
    { value: "RFIS", label: "RFIS" },
    { value: "Schedule Update", label: "Schedule Update" },
    { value: "Shop Drawings", label: "Shop Drawings" },
    { value: "Statutory OC Drawings", label: "Statutory OC Drawings" }
];

